export default __webpack_public_path__ + "static/media/Map_default_message_with_bg.543eefcf.png";